export default __webpack_public_path__ + "static/media/line2.54b62da4.svg";